import React from 'react';
import { esChunkError, recuperarDeChunkError } from '../lib/appUpdate';

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, recuperando: false }; }
  static getDerivedStateFromError(error) {
    // Si es un fallo de chunk (bundle viejo tras un deploy), mostramos "Actualizando…" sin parpadeo de error.
    return { error, recuperando: esChunkError(error) };
  }
  componentDidCatch(error, info) {
    if (esChunkError(error)) {
      // Recupera sola: desregistra SW, limpia cachés y recarga una vez.
      recuperarDeChunkError().then((hecho) => { if (!hecho) this.setState({ recuperando: false }); });
      return;
    }
    console.error('HUECO error:', error, info);
  }
  render() {
    if (this.state.recuperando) {
      return (
        <div className="center-page">
          <div className="card stack" style={{ maxWidth: 460, textAlign: 'center', alignItems: 'center' }} data-testid="chunk-recuperando">
            <div className="spin" aria-hidden />
            <h2>Actualizando HUECO…</h2>
            <p className="muted small">Hay una versión nueva. Cargando en un momento.</p>
          </div>
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div className="center-page">
          <div className="card stack" style={{ maxWidth: 460 }} data-testid="error-boundary">
            <h2>Algo ha fallado</h2>
            <p className="muted small">{String(this.state.error.message || this.state.error)}</p>
            <button className="btn" onClick={() => window.location.reload()}>Recargar</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
